import React from "react"
import { Box, Button, IconButton } from "@mui/material"
import { useLang } from "~/hooks/useLang"
import { FilterNoneOutlined, LibraryAddCheckOutlined, ToggleOn } from '@mui/icons-material';
import type { State, StateMethods } from "@hookstate/core";
import type IUser from "~/features/User/interfaces/IUser";

interface CheckBoxCrudProps {
  readonly enabledCheckBox: boolean | undefined;
  readonly handleCheckBox: () => void;
  readonly openDialogDeactivatedMultipleUser: State<boolean> | undefined;
  readonly rowsSelected: StateMethods<IUser[]> | undefined;
  readonly enableButtonShowResume: StateMethods<boolean> | undefined;
  readonly openModalResultMultipleDeactivatedUsers: StateMethods<boolean> | undefined;
 }

export default function CheckBoxCrud({
  enabledCheckBox,
  handleCheckBox,
  openDialogDeactivatedMultipleUser,
  rowsSelected,
  enableButtonShowResume,
  openModalResultMultipleDeactivatedUsers
}: CheckBoxCrudProps) {
  const { translate } = useLang()
  
  return (
    <Box>
      <IconButton
        onClick={() => handleCheckBox()}
        title={enabledCheckBox ? translate('Disable Select') : translate('Enable Select')}
        size="large"
      >
        {enabledCheckBox ? <LibraryAddCheckOutlined fontSize='small' /> : <FilterNoneOutlined fontSize='small' />}
      </IconButton>

      <IconButton
        onClick={() => openDialogDeactivatedMultipleUser?.set(true)}
        title={translate('Deactivate user multiple')}
        size="large"
        disabled={rowsSelected?.get() && rowsSelected?.get().length < 2}
      >
        {<ToggleOn fontSize='small' />}
      </IconButton>
      {enableButtonShowResume?.get() &&
        <Button
          variant='text'
          onClick={() => openModalResultMultipleDeactivatedUsers?.set(true)}
          sx={{
            '&:hover': {
              textDecoration: 'underline',
              background: "none",
            }
          }}
        >
          {translate('View the latest batch user deactivation')}
        </Button>
      }
    </Box>
  )
}
